<template>
  <div class="investigadores">
    <p class="titleColorSystem text-center">investigadores</p>
    <div class="sci-inv-texto">
      Aquí se pueden observar los investigadores registrados en la plataforma de
      {{ this.configuracion.siglas_institucion }}. Así como también se puede hacer una búsqueda mediante los filtros
      por área de conocimiento, campo y disciplina con que cuenta cada uno y si
      pertenece al Sistema Nacional de Investigadores (SNI) ó al Sistema Estatal
      de Investigadores (SEI).
    </div>
    <div>
      <v-container row wrap>
        <v-flex md4 xs12>
          <v-select
            :items="search_items"
            label="Buscar por ..."
            item-text="name"
            item-value="id"
            v-model="tipo_search"
          ></v-select>
        </v-flex>
      </v-container>
    </div>
    <div v-if="tipo_search == null">
      <h3 class="font-weight-thin mb-3 text-center">SIN INFORMACIÓN</h3>
      <h4 class="subheading text-center">
        POR FAVOR ELIJA UNA CATEGORÍA MEDIANTE EL SELECT
      </h4>
    </div>
    <div class="sci-inv-content" v-if="tipo_search == 2">
      <div>
        <table class="sci-inv-table">
          <thead class="sci-inv-thead">
            <div class="sci-inv-busqueda">
              <!-- Input Select -->
              <v-flex md12 xs12>
                <v-text-field
                  label="Buscar"
                  placeholder="Buscar por palabra clave"
                  v-model="search_lineas"
                  append-icon="arrow_forward_ios"
                  hide-details
                  clearable
                  flat
                  prepend-inner-icon="search"
                  @change="
                    getLineas(page, search_lineas),
                      getLineasExcel(page, search_lineas)
                  "
                >
                </v-text-field>
              </v-flex>
            </div>

            <span class="sci-inv-count"
              >Hay
              {{ isNaN(concatLineas) ? null : concatLineas }} investigadores que
              coinciden con el filtro </span
            ><br />
            <vue-excel-xlsx
              v-if="concatLineas > 0"
              class="sci-inv-excel"
              :data="lineasInvExcel.data"
              :columns="columns_lineas"
              :filename="'Investigadores'"
              :sheetname="'investigadores'"
            >
              Descargar resultados
            </vue-excel-xlsx>
            <tr class="sci-inv-tr1">
              <td class="sci-inv-tr1-nom">Nombre</td>
              <td class="sci-inv-tr1-area">Area del conocimiento</td>
              <td class="sci-inv-tr1-camp">Campo</td>
              <td class="sci-inv-tr1-dis">Disciplina</td>
              <td class="sci-inv-tr1-sni">SNI</td>
              <td class="sci-inv-tr1-sei">SEI</td>
              <td class="sci-inv-tr1-sei">Líneas de Investigación</td>
              <td class="sci-prod-thead-nom">contacto</td>
            </tr>
          </thead>

          <tbody class="sci-inv-tbody">
            <tr
              class="sci-inv-tr2"
              v-for="investigador_lineas in lineasInv.data"
              :key="investigador_lineas.id"
            >
              <td class="sci-inv-tbody-nom">
                {{
                  investigador_lineas.nombre_completo
                    ? investigador_lineas.nombre_completo
                    : ""
                }}
              </td>

              <td class="sci-inv-tbody-area">
                {{
                  investigador_lineas.area_conocimiento
                    ? investigador_lineas.area_conocimiento.nombre_area
                    : "El investigador no tiene área"
                }}
              </td>

              <td class="sci-inv-tbody-camp">
                {{
                  investigador_lineas.area_conocimiento_campo
                    ? investigador_lineas.area_conocimiento_campo.nombre_campo
                    : "No tiene campo definido"
                }}
              </td>

              <td class="sci-inv-tbody-dis">
                {{
                  investigador_lineas.area_conocimiento_campo_disciplina
                    ? investigador_lineas.area_conocimiento_campo_disciplina
                        .nombre_disciplina
                    : "No tiene disciplina"
                }}
              </td>

              <td class="sci-inv-tbody-sni">
                {{
                  investigador_lineas.prodep_conacyt[0] &&
                  investigador_lineas.prodep_conacyt[0] &&
                  investigador_lineas.prodep_conacyt[0].fecha_fin
                    ? investigador_lineas.prodep_conacyt[0].nivel
                    : (investigador_lineas.prodep_conacyt[0] &&
                        investigador_lineas.prodep_conacyt[0].fecha_fin ===
                          null) ||
                      today <= investigador_lineas.prodep_conacyt[0]
                    ? investigador_lineas.prodep_conacyt[0].nivel +
                      " - no vigente"
                    : ""
                }}
              </td>

              <td class="sci-inv-tbody-sei">
                {{
                  investigador_lineas.reconocimiento != null &&
                  investigador_lineas.reconocimiento !=
                    "Puntaje insuficiente" &&
                  investigador_lineas.reconocimiento != "Puntaje Insuficiente"
                    ? investigador_lineas.reconocimiento
                    : ""
                }}
              </td>
              <td style="text-align: center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      color="primary"
                      v-on="on"
                      flat
                      @click.stop="
                        $set(dialogNote, investigador_lineas.id, true)
                      "
                    >
                      <v-icon>arrow_circle_right</v-icon>
                    </v-btn>
                  </template>
                  <span>Click para ver las Líneas de Investigación</span>
                </v-tooltip>

                <v-dialog
                  v-model="dialogNote[investigador_lineas.id]"
                  scrollable
                  lazy
                  max-width="1000"
                  max-height="600"
                  :key="investigador_lineas.id"
                >
                  <v-card>
                    <v-card-title>
                      <span class="text-primary headline"
                        >Líneas de Investigación</span
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        icon
                        flat
                        @click.stop="
                          $set(dialogNote, investigador_lineas.id, false)
                        "
                        ><v-icon>close</v-icon></v-btn
                      >
                    </v-card-title>
                    <v-card-text>
                      <v-data-table
                        :items="investigador_lineas.linea_gen"
                        class="elevation-1"
                        hide-actions
                        :headers="[
                          {
                            text: 'Título',
                            align: 'left',
                            sortable: false,
                            value: 'título',
                          },
                          {
                            text: 'Descripción',
                            align: 'left',
                            value: 'descripcion',
                          },
                          {
                            text: 'Acciones',
                            align: 'left',
                            value: 'acciones',
                          },
                        ]"
                      >
                        <template v-slot:items="props">
                          <tr
                            v-if="props.item.linea_trabajo[0]"
                            @click="props.expanded = !props.expanded"
                          >
                            <td class="text-xs-left">
                              {{
                                props.item.linea_investigacion
                                  ? props.item.linea_investigacion
                                  : "Sin registro"
                              }}
                            </td>
                            <td class="text-xs-left">
                              {{
                                props.item.descripcion
                                  ? props.item.descripcion
                                  : "Sin registro"
                              }}
                            </td>
                            <td class="text-xs-left">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn color="primary" icon flat v-on="on"
                                    ><v-icon>expand_more</v-icon></v-btn
                                  >
                                </template>
                                <span
                                  >Click para ver las Líneas de Trabajo</span
                                >
                              </v-tooltip>
                            </td>
                          </tr>
                          <tr v-else>
                            <td class="text-xs-left">
                              {{
                                props.item.linea_investigacion
                                  ? props.item.linea_investigacion
                                  : "Sin registro"
                              }}
                            </td>
                            <td class="text-xs-left">
                              {{
                                props.item.descripcion
                                  ? props.item.descripcion
                                  : "Sin registro"
                              }}
                            </td>
                            <td>
                              <v-btn color="primary" disabled icon flat
                                ><v-icon>expand_more</v-icon></v-btn
                              >
                            </td>
                          </tr>
                        </template>
                        <template v-slot:expand="props">
                          <v-container>
                            <v-flex md12>
                              <v-card flat>
                                <v-data-table
                                  :headers="[
                                    {
                                      text: 'Título de la Línea de Trabajo',
                                      align: 'left',
                                      sortable: false,
                                      value: 'titulo',
                                    },
                                    {
                                      text: 'Descripción de la Línea de Trabajo',
                                      align: 'left',
                                      value: 'descripcion',
                                    },
                                  ]"
                                  :items="props.item.linea_trabajo"
                                  class="elevation-1"
                                  hide-actions
                                >
                                  <template v-slot:items="props">
                                    <td class="text-xs-left">
                                      {{
                                        props.item.linea_trabajo
                                          ? props.item.linea_trabajo
                                          : "Sin registro"
                                      }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{
                                        props.item.descripcion
                                          ? props.item.descripcion
                                          : "Sin registro"
                                      }}
                                    </td>
                                  </template>
                                </v-data-table>
                              </v-card>
                            </v-flex>
                          </v-container>
                        </template>
                      </v-data-table>
                    </v-card-text>
                    <v-card-actions> </v-card-actions>
                  </v-card>
                </v-dialog>
              </td>
              <td style="text-align: center" v-if="investigador_lineas">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      color="primary"
                      v-on="on"
                      flat
                      @click.stop="
                        $set(dialogNote3, investigador_lineas.id, true)
                      "
                    >
                      <v-icon>mail_outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Click para Enviar Correo</span>
                </v-tooltip>

                <v-dialog
                  v-model="dialogNote3[investigador_lineas.id]"
                  scrollable
                  lazy
                  max-width="450"
                  :key="investigador_lineas.id"
                >
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card>
                      <v-card-title>
                        <span class="text-primary headline">Enviar correo</span>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          icon
                          flat
                          @click.stop="
                            $set(dialogNote3, investigador_lineas.id, false)
                          "
                          ><v-icon>close</v-icon></v-btn
                        >
                      </v-card-title>
                      <v-card-text>
                        <!-- <v-card-title class="headline">localInv: {{this.investigador.titulo}} </v-card-title> -->
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                v-model="nombre"
                                label="Nombre completo*"
                                required
                                :rules="[(v) => !!v || 'Campo requerido']"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="correo"
                                label="Correo*"
                                required
                                :rules="[
                                  (v) => !!v || 'Campo requerido',
                                  (v) =>
                                    /.+@.+/.test(v) || 'Elige un correo válido',
                                ]"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-textarea
                                v-model="comentarios"
                                label="Comentarios*"
                                required
                                :rules="[(v) => !!v || 'Campo requerido']"
                              ></v-textarea>
                            </v-flex>
                            <v-checkbox
                              v-model="checkbox"
                              :rules="[
                                (v) => !!v || 'Debes aceptar para continuar!',
                              ]"
                              label="Aceptar"
                              required
                            ></v-checkbox>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="green darken-1"
                          :disabled="!valid"
                          flat="flat"
                          @click="sendEmail(investigador_lineas), validate"
                          >Enviar</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-form>
                </v-dialog>
              </td>

              <!-- <td style="text-align: center;" v-if="investigador_lineas.linea_gen">
              <v-menu
              :close-on-content-click="false"
              auto
              offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="primary"
                    v-on="on"
                    :nudge-width="200"
                    
                    flat
                  >
                    <v-icon>
                      menu
                    </v-icon>
                  </v-btn>
                </template>
                <v-card v-for="linea in investigador_lineas.linea_gen" :key="linea.id">
                  <v-card-text class="text-primary">Línea de Investigación</v-card-text>
                    <v-expansion-panel>
                      <v-expansion-panel-content
                      >
                        <template v-slot:header>
                          <v-card-text class="headline text-left">Título:</v-card-text>
                          <v-card-text class="text-xs-left">{{linea.linea_investigacion ? linea.linea_investigacion: "Sin Título"}}</v-card-text>
                            <v-divider></v-divider>
                            <v-card-text class="headline text-left">Descripción:</v-card-text>
                            <v-card-text class="text-xs-left">{{linea.descripcion ? linea.descripcion : "Sin Descripción"}}</v-card-text>
                        </template>
                        <v-divider></v-divider>
                        <v-card v-for="trabajo in linea.linea_trabajo" :key="trabajo.id">
                          <v-card-text class="text-primary">Línea de Trabajo</v-card-text>
                          <v-card-text class="headline text-left">Título:</v-card-text>
                          <v-card-text>{{trabajo.linea_trabajo ? trabajo.linea_trabajo : "Sin Título"}}</v-card-text>
                          <v-card-text class="headline text-left">Descripción:</v-card-text>
                          <v-card-text>{{trabajo.descripcion ? trabajo.descripcion : "Sin Descripción"}}</v-card-text>
                          <v-divider inset></v-divider>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                </v-card>
              </v-menu>
            </td> -->
            </tr>
          </tbody>

          <v-spacer></v-spacer>
          <div class="pagination justify-content-center">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <pagination
                :limit="vPaginator.limit"
                :data="lineasInv"
                @pagination-change-page="getLineas"
              ></pagination>
            </div>
            <v-spacer></v-spacer>
          </div>
          <v-spacer></v-spacer>
        </table>
      </div>
    </div>
    <div class="sci-inv-content" v-if="tipo_search == 1">
      <table class="sci-inv-table">
        <thead class="sci-inv-thead">
          <div class="sci-inv-busqueda">
            <!-- Input Select -->
            <v-flex class="sci-inv-vflex" xs12 sm12 md12>
              <v-select
                class="sci-select"
                :items="area"
                item-text="nombre_area"
                item-value="id"
                label="Area de Conocimiento"
                v-model="modelArea"
                light
              ></v-select>
              <!-- clearable="" -->
            </v-flex>
            <v-flex class="sci-inv-vflex" xs12 sm12 md12>
              <v-select
                class="sci-select"
                :items="campos"
                item-text="nombre_campo"
                item-value="id"
                label="Campo"
                v-model="modelCampo"
                light
              ></v-select>
              <!-- clearable="" -->
            </v-flex>
            <v-flex class="sci-inv-vflex" xs12 sm12 md12>
              <v-select
                class="sci-select"
                :items="disciplina"
                item-text="nombre_disciplina"
                item-value="id"
                label="Disciplina"
                v-model="modelDisciplina"
                light
              ></v-select>
              <!-- clearable="" -->
            </v-flex>
            <form class="sci-inv-form">
              <label class="sci-select" style="color: #0d47a1"
                >SNI
                <input
                  v-model="checkboxSniSelected"
                  style="width: none"
                  type="checkbox"
                />
              </label>
            </form>
            <form class="sci-inv-form">
              <label class="sci-select" style="color: #0d47a1"
                >SEI
                <input
                  v-model="checkboxSeiSelected"
                  style="width: none"
                  type="checkbox"
                />
              </label>
            </form>
          </div>
          <span class="sci-inv-count"
            >Hay {{ invCount }} investigadores que coinciden con el filtro </span
          ><br />
          <vue-excel-xlsx
            v-if="investigadores.data.length > 0"
            class="sci-inv-excel"
            :data="investigadoresExcel.data"
            :columns="columns"
            :filename="'Investigadores'"
            :sheetname="'investigadores'"
          >
            Descargar resultados
          </vue-excel-xlsx>
          <tr class="sci-inv-tr1">
            <td class="sci-inv-tr1-nom">Nombre</td>
            <td class="sci-inv-tr1-area">Area del conocimiento</td>
            <td class="sci-inv-tr1-camp">Campo</td>
            <td class="sci-inv-tr1-dis">Disciplina</td>
            <td class="sci-inv-tr1-sni">SNI</td>
            <td class="sci-inv-tr1-sei">SEI</td>
            <td class="sci-inv-tr1-sei">Líneas de Investigación</td>
            <td class="sci-inv-tr1-sei">Contacto</td>
          </tr>
        </thead>
        <tbody class="sci-inv-tbody">
          <!-- sn <pre>{{sn}}</pre> -->
          <tr
            v-for="investigador in investigadores.data"
            :key="investigador.id"
            class="sci-inv-tr2"
          >
            <td class="sci-inv-tbody-nom">
              {{ investigador.nombre_completo }}
            </td>
            <td class="sci-inv-tbody-area">
              {{
                investigador.area_conocimiento
                  ? investigador.area_conocimiento.nombre_area
                  : "El investigador no tiene área"
              }}
            </td>
            <td class="sci-inv-tbody-camp">
              {{
                investigador.area_conocimiento_campo
                  ? investigador.area_conocimiento_campo.nombre_campo
                  : "No tiene campo definido"
              }}
            </td>
            <td class="sci-inv-tbody-dis">
              {{
                investigador.area_conocimiento_campo_disciplina
                  ? investigador.area_conocimiento_campo_disciplina
                      .nombre_disciplina
                  : "No tiene disciplina"
              }}
            </td>
            <td class="sci-inv-tbody-sni">
              {{
                investigador.prodep_conacyt[0] &&
                investigador.prodep_conacyt[0] &&
                investigador.prodep_conacyt[0].fecha_fin
                  ? investigador.prodep_conacyt[0].nivel
                  : (investigador.prodep_conacyt[0] &&
                      investigador.prodep_conacyt[0].fecha_fin === null) ||
                    today <= investigador.prodep_conacyt[0]
                  ? investigador.prodep_conacyt[0].nivel + " - no vigente"
                  : ""
              }}
            </td>
            <td class="sci-inv-tbody-sei">
              {{
                investigador.reconocimiento != null &&
                investigador.reconocimiento != "Puntaje insuficiente" &&
                investigador.reconocimiento != "Puntaje Insuficiente"
                  ? investigador.reconocimiento
                  : ""
              }}
            </td>
            <td style="text-align: center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :disabled="!investigador.linea_gen[0]"
                    icon
                    color="primary"
                    v-on="on"
                    small
                    flat
                    @click.stop="$set(dialogNote2, investigador.id, true)"
                  >
                    <v-icon>arrow_circle_right</v-icon>
                  </v-btn>
                </template>
                <span>Click para ver las Líneas de Investigación</span>
              </v-tooltip>

              <v-dialog
                v-model="dialogNote2[investigador.id]"
                scrollable
                lazy
                max-width="1000"
                max-height="600"
                :key="investigador.id"
              >
                <v-card>
                  <v-card-title>
                    <span class="text-primary headline"
                      >Líneas de Investigación</span
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      icon
                      flat
                      @click.stop="$set(dialogNote2, investigador.id, false)"
                      ><v-icon>close</v-icon></v-btn
                    >
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :items="investigador.linea_gen"
                      class="elevation-1"
                      hide-actions
                      :headers="[
                        {
                          text: 'Título',
                          align: 'left',
                          sortable: false,
                          value: 'titulo',
                        },
                        {
                          text: 'Descripción',
                          align: 'left',
                          value: 'descripcion',
                        },
                        { text: 'Acciones', align: 'left', value: 'acciones' },
                      ]"
                    >
                      <template v-slot:items="props">
                        <tr
                          v-if="props.item.linea_trabajo[0]"
                          @click="props.expanded = !props.expanded"
                        >
                          <td class="text-xs-left">
                            {{
                              props.item.linea_investigacion
                                ? props.item.linea_investigacion
                                : "Sin registro"
                            }}
                          </td>
                          <td class="text-xs-left">
                            {{
                              props.item.descripcion
                                ? props.item.descripcion
                                : "Sin registro"
                            }}
                          </td>
                          <td class="text-xs-left">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn color="primary" icon flat v-on="on"
                                  ><v-icon>expand_more</v-icon></v-btn
                                >
                              </template>
                              <span>Click para ver las Líneas de Trabajo</span>
                            </v-tooltip>
                          </td>
                        </tr>
                        <tr v-else>
                          <td class="text-xs-left">
                            {{
                              props.item.linea_investigacion
                                ? props.item.linea_investigacion
                                : "Sin registro"
                            }}
                          </td>
                          <td class="text-xs-left">
                            {{
                              props.item.descripcion
                                ? props.item.descripcion
                                : "Sin registro"
                            }}
                          </td>
                          <td>
                            <v-btn color="primary" disabled icon flat
                              ><v-icon>expand_more</v-icon></v-btn
                            >
                          </td>
                        </tr>
                      </template>

                      <template v-slot:expand="props">
                        <v-container>
                          <v-flex md12>
                            <v-card flat>
                              <v-data-table
                                :headers="[
                                  {
                                    text: 'Título de la Línea de Trabajo',
                                    align: 'left',
                                    sortable: false,
                                    value: 'titulo',
                                  },
                                  {
                                    text: 'Descripción de la Línea de Trabajo',
                                    align: 'left',
                                    value: 'descripcion',
                                  },
                                ]"
                                :items="props.item.linea_trabajo"
                                class="elevation-1"
                                hide-actions
                              >
                                <template v-slot:items="props">
                                  <td class="text-xs-left">
                                    {{
                                      props.item.linea_trabajo
                                        ? props.item.linea_trabajo
                                        : "Sin registro"
                                    }}
                                  </td>
                                  <td class="text-xs-left">
                                    {{
                                      props.item.descripcion
                                        ? props.item.descripcion
                                        : "Sin registro"
                                    }}
                                  </td>
                                </template>
                              </v-data-table>
                            </v-card>
                          </v-flex>
                        </v-container>
                      </template>
                    </v-data-table>
                  </v-card-text>
                  <v-card-actions> </v-card-actions>
                </v-card>
              </v-dialog>
            </td>
            <td style="text-align: center" v-if="investigador">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    color="primary"
                    v-on="on"
                    flat
                    @click.stop="$set(dialogNote4, investigador.id, true)"
                  >
                    <v-icon>mail_outline</v-icon>
                  </v-btn>
                </template>
                <span>Click para Enviar Correo</span>
              </v-tooltip>

              <v-dialog
                v-model="dialogNote4[investigador.id]"
                scrollable
                lazy
                max-width="450"
                :key="investigador.id"
              >
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-card>
                    <v-card-title>
                      <span class="text-primary headline">Enviar correo</span>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        icon
                        flat
                        @click.stop="$set(dialogNote4, investigador.id, false)"
                        ><v-icon>close</v-icon></v-btn
                      >
                    </v-card-title>
                    <v-card-text>
                      <!-- <v-card-title class="headline">localInv: {{this.investigador.titulo}} </v-card-title> -->
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm12 md12>
                            <v-text-field
                              v-model="nombre"
                              label="Nombre completo*"
                              required
                              :rules="[(v) => !!v || 'Campo requerido']"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              v-model="correo"
                              label="Correo*"
                              required
                              :rules="[
                                (v) => !!v || 'Campo requerido',
                                (v) =>
                                  /.+@.+/.test(v) || 'Elige un correo válido',
                              ]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea
                              v-model="comentarios"
                              label="Comentarios*"
                              required
                              :rules="[(v) => !!v || 'Campo requerido']"
                            ></v-textarea>
                          </v-flex>

                          <v-checkbox
                            v-model="checkbox"
                            :rules="[
                              (v) => !!v || 'Debes aceptar para continuar!',
                            ]"
                            label="Aceptar"
                            required
                          ></v-checkbox>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn
                        color="green darken-1"
                        :disabled="!valid"
                        flat="flat"
                        @click="sendEmail(investigador), validate"
                        >Enviar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-dialog>
            </td>
            <!-- <td style="text-align: center;" v-if="investigador.linea_gen">
              <v-menu offset-y 
              :close-on-content-click="false"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="primary"
                    v-on="on"
                    :nudge-width="200"
                    offset- x
                    flat
                  >
                    <v-icon>
                      menu
                    </v-icon>
                  </v-btn>
                </template>
                <v-card v-for="linea in investigador.linea_gen" :key="linea.id">
                  <v-card-text class="text-primary">Línea de Investigación</v-card-text>
                    <v-expansion-panel>
                      <v-expansion-panel-content
                      >
                        <template v-slot:header>
                          <v-card-text class="headline text-left">Título:</v-card-text>
                          <v-card-text class="text-xs-left">{{linea.linea_investigacion ? linea.linea_investigacion: "Sin Título"}}</v-card-text>
                            <v-divider></v-divider>
                            <v-card-text class="headline text-left">Descripción:</v-card-text>
                            <v-card-text class="text-xs-left">{{linea.descripcion ? linea.descripcion : "Sin Descripción"}}</v-card-text>
                        </template>
                        <v-divider></v-divider>
                        <v-card v-for="trabajo in linea.linea_trabajo" :key="trabajo.id">
                          <v-card-text class="text-primary">Línea de Trabajo</v-card-text>
                          <v-card-text class="headline text-left">Título:</v-card-text>
                          <v-card-text>{{trabajo.linea_trabajo ? trabajo.linea_trabajo : "Sin Título"}}</v-card-text>
                          <v-card-text class="headline text-left">Descripción:</v-card-text>
                          <v-card-text>{{trabajo.descripcion ? trabajo.descripcion : "Sin Descripción"}}</v-card-text>
                          <v-divider inset></v-divider>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-card>
              </v-menu>
            </td> -->
          </tr>
        </tbody>
        <v-spacer></v-spacer>
        <div class="pagination justify-content-center">
          <pagination
            :limit="vPaginator.limit"
            :data="investigadores"
            @pagination-change-page="listarInvestigadores"
          ></pagination>
        </div>
        <v-spacer></v-spacer>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations, mapActions } from "vuex";
import { setTimeout } from "timers";
import InvestigadorEmail from "./InvestigadorEmail";
export default {
  name: "investigadores",
  props: ["urlApi","configuracion"],
  components: {
    InvestigadorEmail,
  },
  data() {
    return {
      valid: true,
      page: 1,
      search: "",
      nombre: "",
      correo: "",
      comentarios: "",
      dialogNote: {},
      dialogNote2: {},
      dialogNote3: {},
      dialogNote4: {},
      dialog: false,
      search_lineas: "",
      tipo_search: null,
      search_items: [
        { name: "Area de Conocimiento", id: "1" },
        { name: "Líneas de Investigación", id: "2" },
      ],
      columns: [
        { label: "Nombre del investigador", field: "nombre_completo" },
        { label: "Area", field: "nombre_area" },
        { label: "Campo", field: "nombre_campo" },
        { label: "Disciplina", field: "nombre_disciplina" },
        { label: "SNI", field: "nivel_sni" },
        { label: "SEI", field: "nivel_sei" },
      ],
      columns_lineas: [
        { label: "Nombre del investigador", field: "nombre_completo" },
        { label: "Area", field: "nombre_area" },
        { label: "Campo", field: "nombre_campo" },
        { label: "Disciplina", field: "nombre_disciplina" },
        { label: "SNI", field: "nivel_sni" },
        { label: "SEI", field: "nivel_sei" },
      ],
      today: new Date().toISOString().slice(0, 10),
      modelArea: null,
      modelCampo: "",
      modelDisciplina: "",
      checkboxSniSelected: 0,
      checkboxSeiSelected: 0,
      area: [],
      investigadores: {
        current_page: 1,
        data: [],
      },
      investigadoresExcel: {},
      sni: {
        current_page: 1,
        data: [],
      },
      sei: {
        current_page: 1,
        data: [],
      },
      vPaginator: {
        limit: 10,
      },
      currentArea: [],
      clearable: false,
      lineasInv: {
        current_page: 1,
        data: [],
      },
      lineasInvExcel: {
        data: [],
        default: () => [],
      },
      lineasTrab: [],
      lineas: [],
      lineasInvTotal: [],
      lineasTrabTotal: [],
    };
  },
  watch: {
    // search_lineas: function(value){
    //    this.getLineas();
    //    this.getLineasExcel();

    // },
    modelArea: function (value) {
      this.modelCampo = "";
      this.modelDisciplina = "";
      this.listarInvestigadores();
      this.getInvestigadores();
    },
    modelCampo: function (value) {
      this.modelDisciplina = "";
      this.listarInvestigadores();
      this.getInvestigadores();
    },
    modelDisciplina: function (value) {
      this.listarInvestigadores();
      this.getInvestigadores();
    },
    checkboxSniSelected: function (value) {
      this.listarInvestigadores();
      this.getInvestigadores();
    },
    checkboxSeiSelected: function (value) {
      this.listarInvestigadores();
      this.getInvestigadores();
    },
  },
  created() {
    this.listarInvestigadores();
    this.listarAreas();
    this.getSni();
    this.getSei();
    this.getInvestigadores();
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    sendEmail: function (investigador) {
      window.open(
        `mailto:seicti@cocyted.gob.mx?subject=Me interesa contactar al investigador&body=Nombre: ${this.nombre},%0D%0ACorreo: ${this.correo},%0D%0AMensaje: ${this.comentarios},%0D%0A%0D%0AInvestigador:%0D%0AFolio: ${investigador.folio}%0D%0ANombre: ${investigador.nombre_completo}`
      );
      (this.nombre = ""),
        (this.correo = ""),
        (this.comentarios = ""),
        (this.dialog = false);
    },
    getLineas: function (page = 1) {
      var url= process.env.VUE_APP_API_URL + `/api/lineas-inv-page?page=${page}&query=${this.search_lineas}`;
      axios
        .get(url)
        .then((response) => {
          this.lineasInv = response.data;
        })
        .catch((error) => errorHandling(error));
    },

    getLineasExcel: function () {
      var url= process.env.VUE_APP_API_URL + `/api/lineas-inv-page?perPage=200&page=1&query=${this.search_lineas}`;
      axios
        .get(url)
        .then((response) => {
          this.lineasInvExcel = response.data;
        })
        .catch((error) => errorHandling(error));
    },

    getSni() {
      var url = process.env.VUE_APP_API_URL + "/api/sni";
      axios.get(url).then((response) => {
        this.sni = response.data;
      });
    },
    getSei() {
      var url = process.env.VUE_APP_API_URL + "/api/sei";
      axios.get(url).then((response) => {
        this.sei = response.data;
      });
    },
    listarAreas() {
      var url = process.env.VUE_APP_API_URL + "/api/areas";
      axios.get(url).then((response) => {
        this.area = response.data.data;
      });
    },
    listarInvestigadores: function (page = 1) {
      var url= process.env.VUE_APP_API_URL + `/api/investigador?page=${page}&query=${
            this.modelArea
          }
          &secondQuery=${this.modelCampo}&thirdQuery=${this.modelDisciplina}
          &fourthQuery=${this.checkboxSniSelected == 1 ? 1 : 0}
          &fiveQuery=${this.checkboxSeiSelected == 1 ? 1 : 0}`;
      axios
        .get(url)
        .then((response) => {
          this.investigadores = response.data;
        })
        .catch((error) => errorHandling(error));
    },
    getInvestigadores: function () {
      var url= process.env.VUE_APP_API_URL + `/api/investigador?perPage=200&page=1&query=${
            this.modelArea
          }
          &secondQuery=${this.modelCampo}&thirdQuery=${this.modelDisciplina}
          &fourthQuery=${this.checkboxSniSelected == 1 ? 1 : 0}
          &fiveQuery=${this.checkboxSeiSelected == 1 ? 1 : 0}`;
      axios
        .get(url)
        .then((response) => {
          this.investigadoresExcel = response.data;
        })
        .catch((error) => errorHandling(error));
    },
    ...mapActions(["traerAreas"]),
  },
  computed: {
    ...mapState(["areas"]),
    invCount() {
      return this.investigadores.total;
    },

    concatLineas() {
      return this.lineasInv.total;
    },
    campos() {
      var area_id = this.modelArea;
      var found = this.area.find((element) => {
        if (element.id == area_id) {
          return element;
        }
      });
      if (found != null) {
        return found.campo;
      }
    },
    disciplina() {
      var campo_id = this.modelCampo;
      if (this.campos != null) {
        var found = this.campos.find(function (element) {
          if (element.id == campo_id) {
            return element;
          }
        });
        if (found != null) {
          return found.disciplina;
        }
      }
    },
  },
};
</script>

<style>
.investigadores {
  margin-bottom: 2%;
}
.sci-inv-title {
  margin: 3% auto 0%;
  text-transform: uppercase;
  color: rgba(255, 196, 0, 0.9);
  font-weight: bold;
  font-size: 1.5em;
}
.sci-inv-dot {
  font-weight: bold;
  color: rgba(0, 152, 255, 0.9);
}
.sci-inv-dot:before {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-right: 1.2%;
  border-radius: 1px 1px;
}
.sci-inv-dot:after {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-left: 1.2%;
  border-radius: 0 0 0 0;
}
.sci-inv-texto {
  width: 50%;
  margin: 1% auto;
  line-height: 1.5;
}
.sci-inv-content {
  display: grid;
  grid-template-areas: "sci-inv-table sci-inv-show";
  grid-template-columns: 1fr;
  margin-bottom: 100px;
}
.sci-inv-table {
  display: grid;
  grid-area: sci-inv-table;
  border-spacing: 0;
  margin: 0 auto;
  width: 90%;
  align-content: start;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-inv-thead {
  background: transparent;
  color: #000;
  text-align: left;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  /* border: 1px solid #007bff; */
  /* border: 1px solid #aaa; */
}
.sci-inv-busqueda {
  display: grid;
  justify-content: start;
  width: 100%;
  grid-template-columns: 3fr 3fr 3fr 1fr 1fr;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 5px 5px 5px 5px;
  /* border: 1px solid #aaa; */
  /* background-color: #00002e */
}
.sci-inv-vflex {
  width: 95%;
}
.v-label,
.v-select__selection--comma {
  color: #0d47a1 !important;
}
.theme--light.v-icon {
  color: #0d47a1;
}
.sci-inv-form {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
}
.sci-inv-form label {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-content: center;
  cursor: pointer;
  margin-bottom: 0;
}
.sci-inv-form label input {
  cursor: pointer;
  margin-top: 7%;
  width: 17px;
  height: 17px;
  justify-self: center;
}
.sci-inv-form label input:checked {
  background-position: 0 -220px;
  border-radius: 50%;
}
.sci-inv-count {
  color: #0d47a1;
  font-size: 1.03rem;
  font-weight: bold;
}
.sci-inv-excel {
  font-weight: bold;
  color: rgb(117, 180, 239);
  font-size: 1.1rem;
  border: 1px solid #ccc;
  padding: 0.4rem;
  margin: 1rem 0 0 0;
  border-radius: 5px;
}
.sci-inv-tr1 {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  text-transform: uppercase;
  font-weight: 100;
  margin-top: 2.5%;
  font-weight: bold;
  background-color: gainsboro;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 5px 5px 5px 5px;
}
.sci-inv-tbody {
  /* border-left: 1px solid #000;
		border-right: 1px solid #000; */
  text-align: left;
  padding: 15px;
}
.sci-inv-tr2 {
  text-transform: uppercase;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
}
.sci-inv-tr2 td {
  padding: 10px;
  /* border-bottom: 1px solid #000; */
}
.sci-inv-show {
  display: grid;
  width: 90%;
  grid-area: sci-inv-show;
  background: rgba(245, 245, 245, 1);
  min-height: 200px;
  max-height: 700px;
}
.sci-inv-nameInv {
  text-align: left;
  margin: 2% 4%;
  color: rgba(0, 132, 255, 1);
  font-size: 1.7em;
}
.sci-inv-cont-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.sci-inv-info1 {
  display: grid;
  width: 80%;
  margin: 0 auto;
}
.sci-inv-info1 div {
  padding: 15px 0;
}
.sci-inv-info1-p1,
.sci-inv-info1-p2,
.sci-inv-info1-p3,
.sci-inv-info1-p4 {
  text-transform: uppercase;
  font-weight: bold;
}
.sci-inv-info2 {
  display: grid;
}
.sci-inv-info2-p1,
.sci-inv-info2-p2,
.sci-inv-info2-p3,
.sci-inv-info2-p4 {
  text-transform: uppercase;
  font-weight: bold;
}
.sci-inv-tr1-folio,
.sci-inv-tr1-nom,
.sci-inv-tr1-area,
.sci-inv-tr1-camp,
.sci-inv-tr1-dis,
.sci-inv-tr1-sei,
.sci-inv-tr1-sni {
  margin: auto 10px;
}

@media only screen and (max-width: 1400px) and (min-width: 100px) {
  .sci-inv-tr1-nom {
    min-width: 17%;
  }
  .sci-inv-tr1-area {
    min-width: 17%;
  }
  .sci-inv-tr1-camp {
    min-width: 17%;
  }
  .sci-inv-tr1-dis {
    min-width: 17%;
  }
  .sci-inv-tr1-sni {
    min-width: 20%;
  }
  .sci-inv-tr1-sei {
    min-width: 14%;
  }
  .sci-inv-tbody-nom {
    min-width: 17%;
  }
  .sci-inv-tbody-area {
    min-width: 17%;
  }
  .sci-inv-tbody-camp {
    min-width: 17%;
  }
  .sci-inv-tbody-dis {
    min-width: 17%;
  }
  .sci-inv-tbody-sni-2 {
    min-width: 17%;
  }
}
@media only screen and (max-width: 1000px) and (min-width: 100px) {
  .sci-select {
    font-size: 0.75em;
  }
  .sci-inv-tr1-nom {
    font-size: 0.85em;
  }
  .sci-inv-tr1-area {
    font-size: 0.85em;
  }
  .sci-inv-tr1-camp {
    font-size: 0.85em;
  }
  .sci-inv-tr1-dis {
    font-size: 0.85em;
  }
  .sci-inv-tr1-sni {
    font-size: 0.85em;
  }
  .sci-inv-tr1-sei {
    font-size: 0.85em;
  }
  .sci-inv-tbody-nom {
    font-size: 0.85em;
  }
  .sci-inv-tbody-area {
    font-size: 0.85em;
  }
  .sci-inv-tbody-camp {
    font-size: 0.85em;
  }
  .sci-inv-tbody-dis {
    font-size: 0.85em;
  }
  .sci-inv-tbody-sni-2 {
    font-size: 0.85em;
  }
  .sci-inv-tbody-sei {
    font-size: 0.85em;
  }
}
@media only screen and (max-width: 850px) and (min-width: 100px) {
  .sci-inv-content {
    grid-template-areas: "sci-inv-table";
    grid-template-columns: 1fr;
  }
  .sci-inv-table {
    width: 90%;
    margin: 2% auto;
  }
  .sci-inv-show {
    width: 90%;
    grid-area: auto;
    margin: 0 auto;
  }
  .sci-inv-tbody-dis {
    font-size: 0.55em;
  }
}
@media only screen and (max-width: 600px) and (min-width: 50px) {
  .sci-select {
    min-width: 17%;
  }
  .sci-inv-table {
    width: 97%;
  }
  .sci-inv-thead {
    padding: 6px;
  }
  .sci-inv-form label input {
    align-self: center;
    width: 14px;
    height: 14px;
  }
  .sci-inv-tr1 {
    font-size: 0.85rem;
    margin-top: 1.5%;
  }
  .sci-inv-tr1-nom {
    font-size: 0.8em;
  }
  .sci-inv-tr1-area {
    font-size: 0.75em;
  }
  .sci-inv-tr1-camp {
    font-size: 0.8em;
  }
  .sci-inv-tr1-dis {
    font-size: 0.8em;
  }
  .sci-inv-tr1-sni {
    font-size: 0.8em;
  }
  .sci-inv-tr1-sei {
    font-size: 0.8em;
  }
  .sci-inv-tbody-nom {
    font-size: 0.8em;
  }
  .sci-inv-tbody-area {
    font-size: 0.8em;
  }
  .sci-inv-tbody-camp {
    font-size: 0.8em;
  }
  .sci-inv-tbody-dis {
    font-size: 0.5em;
  }
  .sci-inv-tbody-sni-2 {
    font-size: 0.8em;
  }
  .sci-inv-tbody-sei {
    font-size: 0.8em;
  }
}
@media only screen and (max-width: 500px) and (min-width: 50px) {
  .sci-select {
    font-size: 0.65em;
  }
  .sci-inv-tr1 {
    font-size: 0.85rem;
    margin-top: 1.5%;
  }
  .sci-inv-tr1-nom {
    font-size: 0.7em;
  }
  .sci-inv-tr1-area {
    font-size: 0.75em;
  }
  .sci-inv-tr1-camp {
    font-size: 0.7em;
  }
  .sci-inv-tr1-dis {
    font-size: 0.7em;
  }
  .sci-inv-tr1-sni {
    font-size: 0.7em;
  }
  .sci-inv-tr1-sei {
    font-size: 0.7em;
  }
  .sci-inv-tbody-nom {
    font-size: 0.7em;
  }
  .sci-inv-tbody-area {
    font-size: 0.7em;
  }
  .sci-inv-tbody-camp {
    font-size: 0.7em;
  }
  .sci-inv-tbody-dis {
    font-size: 0.5em;
  }
  .sci-inv-tbody-sni-2 {
    font-size: 0.7em;
  }
  .sci-inv-tbody-sei {
    font-size: 0.7em;
  }
}
.text-center{
  text-align: center;
}
</style>
